import React from 'react';
import { PinpointLiveEditor } from '../live/PinpointLiveEditor';
import type { StudioLiveEditorProps } from '../types/editor.types';

export function PinpointBuilder(props: StudioLiveEditorProps) {
  return <PinpointLiveEditor {...props} />;
}
